export function exhaustiveCheck(param: never, type: string): never {
  throw new TypeError(`${param} is not a proper ${type}`);
}
